<div>
  <h4>Load Contacts Configuration</h4>
  <button title="Add Contact" attr.aria-label="Add Contact" class="button hollow small minor-margin-bottom" (click)="createContact()">
    Add Contact
  </button>
  @for (contact of contacts; track contact; let idx = $index; let isLast = $last) {
    <div>
      <div class="contact-header">
        <h5>Contact #{{idx+1}}</h5>
        <div class="options-container">
          <button title="Edit Contact"
            attr.aria-label="Edit Contact {{idx}}">
            <svg-icon icon="icon-pencil" class="small"
              [class.active]="contact.edit"
              aria-hidden="true" (click)="contact.edit = !contact.edit">
            </svg-icon>
          </button>
          <button title="Delete Contact" attr.aria-label="Delete Contact: {{idx}}">
            <svg-icon icon="icon-trash" class="small" aria-hidden="true" (click)="deleteContact(idx)"></svg-icon>
          </button>
        </div>
      </div>
      <contact-item [(contact)]="contacts[idx]" [edit]="contact.edit" [contextObject]="dataObject"></contact-item>
      @if (!isLast) {
        <hr>
        }
      </div>
    }
  </div>
  <confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
